import Chip from './Chip'
import List from './List'
import Paper from './Paper'
import Tooltip from './Tooltip'
import DataGrid from './DataGrid'

export default function ComponentOverrides() {
	return {
		...Chip(),
		...DataGrid(),
		...List(),
		...Paper(),
		...Tooltip(),
	}
}
